import styled from 'styled-components';

const Container = styled.div`
  display: flex;
`

export default Container;
